import React, { useState, useEffect, useContext } from 'react';
import AppContext from "../../../Store/AppContext";
import { ObterUrlMidia } from '../../../Services/WhatsApp';

const MensagemAudio = ({ mensagem }) => {
    const { contaWhatsAppDefault } = useContext(AppContext);
    const [url, setUrl] = useState(mensagem._mediaUrl);
    const [loading, setLoading] = useState(!mensagem._mediaUrl);

    useEffect(() => {
        if (!url && mensagem.logConversasWhatsAppMediaId) {
            ObterUrlMidia(contaWhatsAppDefault, mensagem.logConversasWhatsAppMediaId).then(({ success, url }) => {
                if (success && url) setUrl(url);
                setLoading(false);
            });
        }
    }, [mensagem]);

    if (loading) return <div>[Carregando áudio...]</div>;
    if (!url) return <div>[Áudio não disponível]</div>;

    return (
        <div className="audio-wrapper">
            <audio
                src={url}
                controls
                controlsList="nodownload noplaybackrate"
                onContextMenu={(e) => e.preventDefault()}
            />
        </div>
    );
};

export default MensagemAudio;
